import React from "react";

const ProgressBar = ({
  color,
  progress = "",
  height = "10px",
  width = "20px",
}) => (
    <div className="progress">
      <div
        className="progress-label-bar"
        style={{ ...color, height, width }}
       />
      {progress}
    </div>
  );

export default ProgressBar;
